import { lazyLoad } from './lazyload-init.js';

// Document ready
$(function(){

    // Add lazyLoad
    let lazyLoadInstance  = lazyLoad();
});